// arsenal-tpms/frontend/src/components/vehicles/detail/RotationPreview.jsx
import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Grid,
    Stack,
    useTheme,
    alpha,
    useMediaQuery
} from '@mui/material';
import { ArrowForward as ArrowIcon } from '@mui/icons-material';

const RotationPreview = ({ vehicle, selectedPositions, t }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (selectedPositions.length !== 2) return null;

    const [pos1, pos2] = selectedPositions;
    const sensor1 = vehicle.vehicle_sensors?.find(vs => vs.position === pos1);
    const sensor2 = vehicle.vehicle_sensors?.find(vs => vs.position === pos2);

    return (
        <Box sx={{ mt: 3 }}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={5}>
                    <Stack spacing={1.5}>
                        <Box sx={{
                            p: 1.5,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                            border: `2px solid ${theme.palette.primary.main}`,
                            bgcolor: alpha(theme.palette.primary.main, 0.08)
                        }}>
                            <Typography variant="caption" color="text.secondary">
                                {t('vehicleDetail.overview.position', 'Posición')} {pos1}
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {sensor1?.sensor_id || t('common.notAvailable', 'N/A')}
                            </Typography>
                        </Box>
                        <Box sx={{
                            p: 1.5,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                            border: `2px solid ${theme.palette.primary.main}`,
                            bgcolor: alpha(theme.palette.primary.main, 0.08)
                        }}>
                            <Typography variant="caption" color="text.secondary">
                                {t('vehicleDetail.overview.position', 'Posición')} {pos2}
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {sensor2?.sensor_id || t('common.notAvailable', 'N/A')}
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>

                <Grid item xs={12} sm={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <ArrowIcon
                        sx={{
                            fontSize: { xs: 32, sm: 40 },
                            color: 'primary.main',
                            transform: isMobile ? 'rotate(90deg)' : 'none'
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={5}>
                    <Stack spacing={1.5}>
                        <Box sx={{
                            p: 1.5,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                            border: `2px solid ${theme.palette.primary.main}`,
                            bgcolor: alpha(theme.palette.primary.main, 0.08)
                        }}>
                            <Typography variant="caption" color="text.secondary">
                                {t('vehicleDetail.overview.position', 'Posición')} {pos1}
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {sensor2?.sensor_id || t('common.notAvailable', 'N/A')}
                            </Typography>
                        </Box>
                        <Box sx={{
                            p: 1.5,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                            border: `2px solid ${theme.palette.primary.main}`,
                            bgcolor: alpha(theme.palette.primary.main, 0.08)
                        }}>
                            <Typography variant="caption" color="text.secondary">
                                {t('vehicleDetail.overview.position', 'Posición')} {pos2}
                            </Typography>
                            <Typography variant="body2" fontWeight={600}>
                                {sensor1?.sensor_id || t('common.notAvailable', 'N/A')}
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
};

export default RotationPreview;